module.exports = __webpack_public_path__ + "img/131.9.78d5d985.png";